import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NavigationComponent } from "./navigation.component";
import { NavigationService } from "./navigation.service";
import { HandleError } from "../utils/handleError.component";

@NgModule({
    declarations: [NavigationComponent],
    imports: [BrowserModule, RouterModule],
    exports: [NavigationComponent],
    providers: [NavigationService, HandleError]
})

export class NavigationModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/navigation/navigation.module.ts